/** Convierte tinyint/boolean/string del API a 0 | 1 (MySQL/JSON a veces devuelven "1" o true). */
function normalizeSystemFlag(value: unknown): 0 | 1 {
  if (value === true || value === 1) return 1;
  if (value === false || value === 0 || value == null) return 0;
  if (typeof value === "string") {
    const t = value.trim().toLowerCase();
    if (t === "1" || t === "true") return 1;
    if (t === "0" || t === "false" || t === "") return 0;
    const n = parseInt(t, 10);
    return n === 1 ? 1 : 0;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return value === 1 ? 1 : 0;
  }
  return 0;
}

/** Alineado con la API: superusuario por flag o usuario superadmin. */
export function isSuperAdminUser(
  user: { isSystem?: unknown; username?: unknown } | null | undefined,
): boolean {
  if (!user || typeof user !== "object") return false;
  const u = user as { isSystem?: unknown; username?: unknown };
  if (normalizeSystemFlag(u.isSystem) === 1) return true;
  return String(u.username ?? "")
    .trim()
    .toLowerCase() === "superadmin";
}

/** Desempaqueta el cuerpo de GET /user (axios): { data: usuario } o anidado. */
export function parseUserFromApiResponse(body: unknown): {
  isSystem?: unknown;
  username?: unknown;
} | null {
  let cur: unknown = body;
  for (let i = 0; i < 4 && cur != null; i++) {
    if (typeof cur === "object" && !Array.isArray(cur)) {
      const o = cur as Record<string, unknown>;
      if ("username" in o || "isSystem" in o || "id" in o) {
        return o as { isSystem?: unknown; username?: unknown };
      }
      if ("data" in o) {
        cur = o.data;
        continue;
      }
    }
    break;
  }
  return null;
}
